import { useState, FormEvent } from 'react';

export default function Contact() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    if (!email || !message) {
      setStatus('error');
      return;
    }

    setStatus('sending');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('message', message);

      const response = await fetch('https://readdy.ai/api/form/d6pa80ua739gopmlgnq0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
        setMessage('');
        setTimeout(() => setStatus('idle'), 3000);
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <section className="px-20 py-20">
      <div className="bg-[#1C1C1E] rounded-[48px] p-[160px_80px] mx-20">
        <div className="flex gap-20">
          {/* Left side - Form */}
          <div className="w-[55%]">
            <h2 className="text-[68px] font-extralight text-white leading-tight mb-12">
              Get In Touch
            </h2>
            <p className="text-xl text-gray-400 mb-[120px]">
              We're here to help with your iOS development needs
            </p>

            <form id="contact_form" data-readdy-form onSubmit={handleSubmit}>
              <div className="mb-12">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  className="w-full bg-transparent border-0 border-b border-gray-600 text-white text-lg py-4 px-0 focus:outline-none focus:border-purple-400 transition-colors placeholder:text-gray-500"
                  required
                />
              </div>

              <div className="mb-12">
                <textarea
                  name="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Your message"
                  maxLength={500}
                  rows={4}
                  className="w-full bg-transparent border-0 border-b border-gray-600 text-white text-lg py-4 px-0 focus:outline-none focus:border-purple-400 transition-colors placeholder:text-gray-500 resize-none"
                  required
                />
                <div className="text-sm text-gray-500 mt-2 text-right">
                  {message.length}/500
                </div>
              </div>

              <button
                type="submit"
                disabled={status === 'sending'}
                className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
              >
                {status === 'sending' ? 'Sending...' : 'Send Message'}
              </button>

              {status === 'success' && (
                <p className="text-green-400 mt-4">Message sent successfully!</p>
              )}
              {status === 'error' && (
                <p className="text-red-400 mt-4">Please fill in all fields correctly.</p>
              )}
            </form>
          </div>

          {/* Right side - Contact Info */}
          <div className="w-[45%] flex flex-col justify-between">
            {/* Contact Information */}
            <div>
              <div className="text-xs uppercase tracking-widest text-white mb-6">
                CONTACT
              </div>
              <div className="space-y-4">
                <p className="text-lg text-white flex items-center gap-3">
                  <i className="ri-phone-line"></i>
                  +1 2297159326
                </p>
                <p className="text-lg text-white flex items-center gap-3">
                  <i className="ri-mail-line"></i>
                  contact@ferarshpk.com
                </p>
              </div>
            </div>

            {/* Address Information */}
            <div className="mt-[100px]">
              <div className="text-xs uppercase tracking-widest text-white mb-5">
                LOCATION
              </div>
              <div className="space-y-1">
                <p className="text-base text-[#A0A0A0] leading-[22px] flex items-start gap-3">
                  <i className="ri-map-pin-line mt-1"></i>
                  <span>Rruga Isa Boletini, Pallati i Shoqerise Ferar</span>
                </p>
                <p className="text-base text-[#A0A0A0] leading-[22px] ml-8">
                  np. 5/740/ND-N8
                </p>
                <p className="text-base text-[#A0A0A0] leading-[22px] ml-8">
                  TIRANE 1000
                </p>
                <p className="text-base text-[#A0A0A0] leading-[22px] ml-8">
                  Albania
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}